import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BackofficeRoles } from '../models/roles.model';
import { UserService } from '../models/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class BackofficeRoleGuard implements CanActivate {

  constructor(private userService : UserService,
    private router : Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.userService.upsUser.backofficeRole == BackofficeRoles.LEGRAND_ADMIN
      || this.userService.upsUser.backofficeRole == BackofficeRoles.LEGRAND_SERVICE) return true;
      else this.router.navigateByUrl('/prelogin');
  }

}
